/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRef, useState } from 'react'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'

const StudentRow = ({ item, onInviteClick }) => {
  const refMenu = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useOnClickOutside(refMenu, () => setIsMenuOpen(false))

  const handleMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <div className="details-table__row">
      <div className="details-table__col details-table__col-1">
        <div className="checkbox">
          <input type="checkbox" />
          <i className="checkbox-ico" />
        </div>
      </div>
      <div className="details-table__col details-table__col-2">
        <div className="details-table__main">
          <div className="details-table__user">
            <a href="#" className="details-table__ava">
              <img src={item.avatar || '/account/img/human-1-min.jpg'} alt="" />
            </a>
            <a href="#" className="details-table__name">
              {item.first_name} {item.last_name}
            </a>
          </div>
          <span className="details-table__text">{item.user_name}</span>
        </div>
      </div>
      <div className="details-table__col details-table__col-3">
        <ul>
          {(item?.classrooms || []).map((x) => (
            <li key={item.id}>{x.subject.name}</li>
          ))}
        </ul>
      </div>
      <div className="details-table__col details-table__col-4">
        <ul className="details-list">
          {(item?.classrooms || []).map((x) => (
            <li key={item.id}>{x.name}</li>
          ))}
        </ul>
      </div>
      <div className={isMenuOpen ? 'dropHb active' : 'dropHb'}>
        <div className="dropHb-top" onClick={handleMenuOpen}>
          <i className="hb-ico dots-ico" />
        </div>
        <div className="dropHb-info" ref={refMenu}>
          <ul>
            <li>
              <a href="#">
                <i className="hb-ico clear-ico" />
                Dismiss
              </a>
            </li>
            <li>
              <a
                onClick={onInviteClick}
                data-fancybox=""
                data-src="#assign"
                href="#"
              >
                <i className="hb-ico checkCircle-ico" />
                Assign to class
              </a>
            </li>
            <li>
              <a href="#">
                <i className="hb-ico report-ico" />
                Report card
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default StudentRow
